import useRoutes from "@/hooks/useRoutes";
import { Button, Stack, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

const OnboardingFinished = () => {
    const { state } = useLocation();
    const [_, getUrl] = useRoutes();
    
    return (
        <Stack spacing={2} justifyContent="center">
            <Typography textAlign="center" variant="h2" color="white">
                ¡Listo!
            </Typography>
            <Typography textAlign="center" variant="h4" color="white">
                Tu restaurante está listo para comenzar a recibir pedidos.
            </Typography>
            {state.organizationId ? (
                <Stack spacing={2}>
                    <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        component={Link}
                        target="_blank"
                        to={getUrl("organizations.root", {
                            organizationAlias: state.alias,
                        })}
                    >
                        Ver Sitio Web
                    </Button>
                    <Button
                        fullWidth
                        color="primary"
                        variant="contained"
                        component={Link}
                        target="_blank"
                        to={getUrl("admin.menus.main", {
                            organizationId: state.organizationId,
                        })}
                    >
                        Ver Menús
                    </Button>
                    <Button
                        fullWidth
                        color="primary"
                        variant="contained"
                        component={Link}
                        target="_blank"
                        to={getUrl("admin.content.main", {
                            organizationId: state.organizationId,
                            contentStatus: "publicados",
                        })}
                    >
                        Gestionar Platos
                    </Button>
                </Stack>
            ) : null}
        </Stack>
    )
}

export default OnboardingFinished;
